import classNames from 'classnames';

// TODO: remove and use another existing svg
const CheckIcon = ({ className, color = '#737373' }) => {
  return (
    <svg
      className={classNames('check-icon', className)}
      xmlns='http://www.w3.org/2000/svg'
      width='13'
      height='14'
      fill='none'
      viewBox='0 0 13 14'
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M.875.906a.469.469 0 00-.469.469v11.25c0 .259.21.469.469.469h11.25c.259 0 .469-.21.469-.469V1.375a.469.469 0 00-.469-.469H.875zM8.53 4.462L5.533 7.731l-1.1-1.101-.885.884 2.024 2.024 3.879-4.231-.921-.845z'
        clipRule='evenodd'
      ></path>
    </svg>
  );
};

export default CheckIcon;
